import React from "react";
import { TitleEnforcementList } from "../../components/title/TitleEnforcementList";
var TitlesWithoutIsbnList = function () { return React.createElement(TitleEnforcementList, { withIsbn: false }); };
export default TitlesWithoutIsbnList;
